"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getModelSchemas () {
        return getModelSchemas;
    },
    get getViewSchemas () {
        return getViewSchemas;
    }
});
const _nocodbsdk = require("nocodb-sdk");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
const getModelSchemas = (ctx)=>{
    var _ctx_columns, _ctx_columns1, _ctx_columns2;
    return {
        [`${ctx.tableName}Response`]: {
            title: `${ctx.tableName} Response`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: _extends({}, ((_ctx_columns = ctx.columns) == null ? void 0 : _ctx_columns.reduce((colsObj, _1)=>{
                let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                    "title",
                    "virtual",
                    "column"
                ]);
                return _extends({}, colsObj, column.system ? {} : {
                    [title]: fieldProps
                });
            }, {})) || {})
        },
        [`${ctx.tableName}Request`]: {
            title: `${ctx.tableName} Request`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: _extends({}, ((_ctx_columns1 = ctx.columns) == null ? void 0 : _ctx_columns1.reduce((colsObj, _1)=>{
                let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                    "title",
                    "virtual",
                    "column"
                ]);
                var _column_meta;
                return _extends({}, colsObj, virtual || (0, _nocodbsdk.isSystemColumn)(column) || column.ai || ((_column_meta = column.meta) == null ? void 0 : _column_meta.ag) ? {} : {
                    [title]: fieldProps
                });
            }, {})) || {})
        },
        [`${ctx.tableName}IdRequest`]: {
            title: `${ctx.tableName} Id Request`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: _extends({}, ((_ctx_columns2 = ctx.columns) == null ? void 0 : _ctx_columns2.reduce((colsObj, _1)=>{
                let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                    "title",
                    "virtual",
                    "column"
                ]);
                return _extends({}, colsObj, column.pk ? {
                    [title]: fieldProps
                } : {});
            }, {})) || {})
        }
    };
};
const getViewSchemas = (ctx)=>{
    var _ctx_columns, _ctx_columns1;
    return {
        [`${ctx.tableName}${ctx.viewName}GridResponse`]: {
            title: `${ctx.tableName} : ${ctx.viewName} Response`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: _extends({}, ((_ctx_columns = ctx.columns) == null ? void 0 : _ctx_columns.reduce((colsObj, _1)=>{
                let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                    "title",
                    "virtual",
                    "column"
                ]);
                return _extends({}, colsObj, {
                    [title]: fieldProps
                });
            }, {})) || {})
        },
        [`${ctx.tableName}${ctx.viewName}GridRequest`]: {
            title: `${ctx.tableName} : ${ctx.viewName} Request`,
            type: 'object',
            description: '',
            'x-internal': false,
            properties: _extends({}, ((_ctx_columns1 = ctx.columns) == null ? void 0 : _ctx_columns1.reduce((colsObj, _1)=>{
                let { title, virtual, column } = _1, fieldProps = _object_without_properties_loose(_1, [
                    "title",
                    "virtual",
                    "column"
                ]);
                return _extends({}, colsObj, virtual ? {} : {
                    [title]: fieldProps
                });
            }, {})) || {})
        }
    };
};
